import { takeLatest, call, put } from "redux-saga/effects";
import {
  fetchDataBegin,
  fetchDataError,
  getAccessControlSuccess,
} from "./slice";
import { apiPost } from "../../api/callApi";
import { getAccessControl } from "./actions";

function* getAccessControlData(val) {
  const id = val.payload;

  yield put(fetchDataBegin());
  try {
    const response = yield call(apiPost, `/v1/projects/accesscontrol/${id}`);
    yield put(getAccessControlSuccess({ newData: response.data }));
  } catch (error) {
    yield put(fetchDataError({ message: error.response.data.message }));
    console.error("Get accesscontrol failed", error);
  }
}

export function* watchAccessControl() {
  yield takeLatest(getAccessControl.type, getAccessControlData);
}
